import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import ClipboardJS from 'clipboard';
import Switch from 'rc-switch';
import Tooltip from 'rc-tooltip';
import styles from './shareDialog.module.scss';
import 'rc-tooltip/assets/bootstrap_white.css';
import 'rc-switch/assets/index.css';
import { toast } from '../../../utils/axios';

const ShareDialog = (props) => {
  const [shareLimitValue, setShareLimitValue] = useState(false);
  useEffect(() => {
    let clipboard = new ClipboardJS('.playback-share-copy');
    return clipboard?.destroy;
  }, []);
  const onChange = (value, event) => {
    setShareLimitValue(value);
    props.onShareLimit(value);
  }
  const onClose = () => {
    props.onCloseShare(false);
  }
  const copySuccess = (url) => {
    console.log('复制成功');
    if (url) {
      toast('复制成功');
      props.onShareSuccess(shareLimitValue);
    }
  }
  return ReactDOM.createPortal(
    <>
      {props.show &&
        <div className={styles.mask}>
          <div className={styles.container}>
            <span className={styles.close} onClick={onClose}></span>
            <p className={styles.title}>知识点分享</p>
            <p className={styles.content}>{props.shareUrl}</p>
            <Switch onChange={onChange} defaultChecked={false} className='shareSwitch' />
            <span className={styles.tip}>仅本班学生可观看</span>
            <button class="playback-share-copy" data-clipboard-text={props.shareUrl || ''} onClick={() => { copySuccess(props.shareUrl)}}>复制分享给学生</button>
          </div>
        </div>
      }
    </>,
    document.getElementById('knowledgePointPlayback') || document.body
  );
}

export default ShareDialog;
